import { render, staticRenderFns } from "./business-admin-role.vue?vue&type=template&id=c1598c44&scoped=true&"
import script from "./business-admin-role.vue?vue&type=script&lang=js&"
export * from "./business-admin-role.vue?vue&type=script&lang=js&"
import style0 from "./business-admin-role.vue?vue&type=style&index=0&id=c1598c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1598c44",
  null
  
)

export default component.exports